import { TODAY_END_TS, TS_60_DAYS_OLD_FROM_NOW } from '../lib/enums';
import Net from '../lib/net';
import { DB, Stores } from '../db/dbschema';
const glHostName = require('../config').config.glHostName;

export function getLatestDailyStatsMdt(vid, cb) {
  getValueByKey(Stores.LatestDailyStatsMdt, vid, null, cb);
}

function getValueByKey(store, key, index, cb) {
  let indexNm = index || null;
  global.indexedDbClient.getValueByKey(DB.GL, store, key, indexNm)
    .then((resp) => { cb(null, (resp || null)); })
    .catch((e) => { cb(e); })
}

export function getDayStats(vid, ts, cb) {
  let storeNm = vid + Stores._DailyStats;
  let key = [vid, ts];
  getValueByKey(storeNm, key, null, cb);
}

export function GetStatsFromDB(params, cb) {
  if (!params.vid) return cb("Vehicle id is missing");
  let lowerBound = [params.vid, params.from || 0];
  let upperBound = [params.vid, params.to || Date.now()];
  let limit = params.limit || null;
  global.indexedDbClient.getDataByRange(DB.GL, params.vid + Stores._DailyStats, null, lowerBound, upperBound, limit)
    .then((resp) => {
      cb(null, resp);
    })
    .catch((e) => {
      console.error("Error while getting stats from indexed DB " + e);
      cb(e);
    })
}

export function GetDailyStats(params, cb) {
  /**
   * First check the latest modified date store in the indexed DB.
   * If mdt is present then fetch daily stats from server whose mdt is greater than stored one.
   * If no present fetch latest stats.
   */
  getLatestDailyStatsMdt(params.vid, (error, mdt) => {
    params.vids = [params.vid];
    if (error) cb(error);
    else {
      if (mdt) {
        _getStatsByMdtFromServer({ vids: [params.vid], mdt }, (statsErr, statsRes) => {
          if (statsErr) cb(statsErr);
          else {
            if (statsRes && statsRes.length) {
              statsRes.forEach(ds => {
                ds.loc = null; // remove loc pings for changed stats which is present in indexedDB
              });
              _saveDailyStatsInDb(statsRes, () => {
                _getDailyStats(params, cb);
              });
            } else _getDailyStats(params, cb);
          }
        });
      } else _getDailyStats(params, cb);
    }
  });
}

function _getDailyStats(params, cb) {
  GetStatsFromDB(params, (err, stats) => {
    if (err) {
      cb(err);
    } else {
      if (stats && stats.length) {
        cb(null, stats);
      } else {
        _getDailyStatsFromServer(params, (e, dstats) => {
          if (e) {
            cb(e);
          } else {
            if (dstats) {
              if (dstats.length) _saveDailyStatsInDb(dstats, cb);
              else cb(null, dstats);
            }
          }
        });
      }
    }
  });
}

function _getStatsByMdtFromServer(params, cb) {
  var url = glHostName + '/gl/users/timeline/getStatsByMdt';
  Net.PostRequest(url, params, (resp) => {
    var data = JSON.parse(resp.response).data;
    if (resp.status === 200) cb(null, data);
    else {
      console.error(data);
      cb("Error while getting daily stats from server by mdt");
    }
  });
}

function _getDailyStatsFromServer(params, cb) {
  if (!params.from) params.from = TS_60_DAYS_OLD_FROM_NOW;
  if (!params.to) params.to = TODAY_END_TS;
  var url = glHostName + '/gl/users/timeline/getstatsbyveh';
  Net.PostRequest(url, params, (resp) => {
    var data = JSON.parse(resp.response).data;
    if (resp.status === 200) cb(null, data);
    else cb("Error while getting daily stats from server");
  });
}

export function _saveDailyStatsInDb(statsArr, cb) {
  if (statsArr.length) {
    statsArr = statsArr.sort((a, b) => b.mdt - a.mdt); // Sort in descending order
    global.indexedDbClient.addMultipleRecords(DB.GL, statsArr[0].vid + Stores._DailyStats, statsArr, true)
      .then(() => {
        return global.indexedDbClient.getValueByKey(DB.GL, Stores.LatestDailyStatsMdt, statsArr[0].vid);
      })
      .then((mdt) => {
        if (!mdt) mdt = 0;
        if (mdt < statsArr[0].mdt) {
          return global.indexedDbClient.addSingleRecord(DB.GL, Stores.LatestDailyStatsMdt, { key: statsArr[0].vid, value: statsArr[0].mdt });
        } else return Promise.resolve();
      }).then(() => {
        cb(null, statsArr);
      })
      .catch((e) => {
        console.error("IndexedDB error while storing todays stats " + e);
        cb(null, statsArr);
      })
  }
}

export function GetStatsFromServer(params, cb) {
  _getDailyStatsFromServer(params, (e, dstats) => {
    if (e) {
      cb(e);
    } else {
      if (dstats) {
        if (dstats.length) _saveDailyStatsInDb(dstats, cb);
        else cb(null, dstats);
      }
    }
  })
}